import { render } from "./QuotationCostDetails.vue?vue&type=template&id=a77b286e"
import script from "./QuotationCostDetails.vue?vue&type=script&lang=js"
export * from "./QuotationCostDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__